import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import * as styles from "./productVideo.module.css";
import { Button, Divider, Modal, Typography } from "@mui/material";
import { FaPlayCircle } from "react-icons/fa";
import { GrFormClose } from "react-icons/gr";
import { getImageURLFromName } from "../../lib/helpers";

const style = {};

const ProductVideo = ({ node }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const {
    productVideoText,
    productVideoUrl,
    productVideoBakground,
    productVideoButtonText,
  } = node;
  let backgroundImage = "";
  if (productVideoBakground && productVideoBakground.asset) {
    backgroundImage = productVideoBakground.asset.url;
  }
  return (
    <Grid container>
      <Grid
        item
        className={styles.productVideoBox}
        style={{
          background: `url(${backgroundImage})`,
        }}
      >
        <Box mb={2}>
          <h2 className={styles.productVideoText}>{productVideoText}</h2>
        </Box>
        <Box mb={3}>
          <Divider className={styles.productVideoDivider} />
        </Box>
        <Box className={styles.centerTextAlign}>
          <Button
            variant="contained"
            onClick={handleOpen}
            className={styles.productVideoButton}
          >
            <FaPlayCircle /> &nbsp;{productVideoButtonText}
          </Button>
        </Box>
      </Grid>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 99999,
        }}
      >
        <Box className={styles.productVideoIframeBox}>
          <GrFormClose
            onClick={handleClose}
            className={styles.productVideoClose}
          />
          <iframe
            className={styles.productVideoIframe}
            src={productVideoUrl + "?autoplay=1"}
            allow="autoplay"
          ></iframe>
        </Box>
      </Modal>
    </Grid>
  );
};

export default ProductVideo;
